import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: { signedOut: 'Вы вышли из аккаунта', moderation: 'Модерация' },
  en: { signedOut: 'You have been signed out', moderation: 'Moderation' },
})
